/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "ok-c2482a0e--sprite",
  "use": "ok-c2482a0e--sprite-usage",
  "viewBox": "0 0 24 25",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 25\" id=\"ok-c2482a0e--sprite\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.016 15.5c-1.549-.158-2.946-.527-4.142-1.431-.148-.114-.301-.222-.437-.348-.523-.486-.576-1.043-.162-1.617.355-.491.95-.623 1.568-.34.12.054.233.123.343.196 2.229 1.481 5.29 1.522 7.528.065.221-.164.458-.298.733-.367.534-.131 1.032.059 1.318.51.328.517.323 1.02-.08 1.42-.619.616-1.363 1.06-2.19 1.37-.781.293-1.637.44-2.485.54.128.135.188.2.268.279 1.15 1.118 2.307 2.232 3.454 3.354.39.383.472.857.257 1.302-.235.486-.762.805-1.278.771-.328-.021-.583-.18-.81-.4-.868-.845-1.752-1.675-2.603-2.537-.248-.25-.367-.203-.585.015-.874.87-1.762 1.727-2.655 2.578-.4.384-.878.451-1.343.233-.495-.232-.81-.72-.785-1.21.017-.332.186-.586.421-.813 1.139-1.1 2.275-2.204 3.41-3.306.076-.073.146-.151.255-.264z\" fill=\"currentColor\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.964 11.615c-2.627-.01-4.78-2.183-4.765-4.81a4.81 4.81 0 014.822-4.79c2.658.007 4.791 2.178 4.778 4.862-.014 2.622-2.182 4.747-4.835 4.738zm2.387-4.804a2.34 2.34 0 00-2.349-2.344A2.343 2.343 0 009.65 6.839a2.34 2.34 0 002.366 2.326 2.335 2.335 0 002.336-2.354z\" fill=\"currentColor\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
